import * as t from "io-ts";

export const LenderRateType = t.union([
  t.literal("regulated"),
  t.literal("unregulated"),
]);

export type LenderRateType = "regulated" | "unregulated";
